<script setup>
defineProps({
  node: { type: Object, required: true },
  depth: { type: Number, default: 0 },
  deleteConfirmId: { type: Number, default: null },
  onEdit: { type: Function, required: true },
  onAddChild: { type: Function, required: true },
  onDelete: { type: Function, required: true },
});
</script>

<template>
  <div>
    <!-- Node row -->
    <div
      class="group flex items-center gap-2 py-1.5 rounded-lg hover:bg-n-alpha-1 transition-colors"
      :style="{ paddingLeft: `${12 + depth * 20}px`, paddingRight: '12px' }"
    >
      <span
        v-if="depth > 0"
        class="i-lucide-corner-down-right size-3 text-n-slate-7 flex-shrink-0"
      />

      <!-- Color dot -->
      <span
        class="size-2.5 rounded-full flex-shrink-0 ring-1 ring-n-weak"
        :style="node.color ? `background:${node.color}` : ''"
        :class="!node.color ? 'bg-n-slate-6' : ''"
      />

      <!-- Name + path indicator -->
      <span class="flex-1 text-sm font-medium text-n-slate-12 truncate">{{
        node.name
      }}</span>

      <!-- Child count -->
      <span
        v-if="node.children?.length"
        class="px-1.5 py-0.5 rounded-full text-[9px] font-bold bg-n-alpha-2 text-n-slate-9 flex-shrink-0"
      >
        {{ node.children.length }} filhos
      </span>

      <!-- Actions -->
      <div class="hidden group-hover:flex items-center gap-1 flex-shrink-0">
        <button
          class="flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] text-n-slate-10 hover:bg-n-brand/10 hover:text-n-brand transition-colors"
          @click.stop="onAddChild(node.id)"
        >
          <span class="i-lucide-plus size-3" />
          Filho
        </button>
        <button
          class="p-1 rounded text-n-slate-9 hover:text-n-brand hover:bg-n-alpha-2 transition-colors"
          @click.stop="onEdit(node.parent_id, node)"
        >
          <span class="i-lucide-pencil size-3" />
        </button>
        <button
          class="p-1 rounded text-n-slate-9 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
          @click.stop="onDelete(node.id)"
        >
          <span class="i-lucide-trash-2 size-3" />
        </button>
      </div>
    </div>

    <!-- Recursive children -->
    <TypeTreeNode
      v-for="child in node.children"
      :key="child.id"
      :node="child"
      :depth="depth + 1"
      :delete-confirm-id="deleteConfirmId"
      :on-edit="onEdit"
      :on-add-child="onAddChild"
      :on-delete="onDelete"
    />
  </div>
</template>
